import { ModuleConfig } from "/@/cool";
import { service } from "/@/cool/service";
import { isStandalonePreviewPage } from "/@/cool/utils/standalone-page";
import {
	registerOssArchiveConfigLoader,
	startOssArchiveIntegrationPolling
} from "./utils/oss-archive-integration";

export default (): ModuleConfig => {
	return {
		order: 199,
		views: [
			{
				path: "/common/message-manage",
				component: () => import("./views/message-manage.vue"),
				meta: {
					label: "消息管理"
				}
			}
		],
		components: [
			import("./components/message-i18n-fields.vue"),
			import("./components/message-receive-record-list.vue"),
			// cool replace
			import("./components/cool/filter/filter-group.vue"),
			import("./components/cool/filter/search.vue"),

			// 业务组件
			import("./components/area/address.vue"),
			import("./components/avatar/index.vue"),
			import("./components/button/cmd.vue"),
			import("./components/button/readytake.vue"),
			import("./components/button/shutdown.vue"),
			import("./components/button/takephoto-order-check.vue"),
			import("./components/button/takephoto-order-view.vue"),
			import("./components/button/order-buttons.vue"),
			import("./components/button/order-views.vue"),
			import("./components/codemirror/index.vue"),
			import("./components/date/datepicker.vue"),
			import("./components/date/text.vue"),
			// dict
			import("./components/dict/dict.vue"),
			// cross hair
			import("./components/cross_hair/index.vue"),
			// dailog
			import("./components/dialog/add-goods.vue"),
			import("./components/dialog/customer-service.vue"),
			import("./components/dialog/model-rebuild-dialog.vue"),
			import("./components/dialog/model-upload.vue"),
			import("./components/dialog/order-dialog.vue"),
			import("./components/dialog/order-goods.vue"),
			import("./components/dialog/out-url.vue"),
			import("./components/dialog/preview-image.vue"),
			import("./components/dialog/preview.vue"),
			import("./components/dialog/repair-check.vue"),

			import("./components/dialog/reprint-order-picker.vue"),
			import("./components/dialog/reprint-order-dialog.vue"), // 新版本
			import("./components/dialog/reserver-print-order-picker.vue"),
			import("./components/dialog/sence-preview-image.vue"),
			import("./components/dialog/settle-log.vue"),
			import("./components/dialog/shop.vue"),
			import("./components/dialog/takephoto-order.vue"),
			import("./components/dialog/takephoto-order-with-print-order.vue"),
			import("./components/dialog/cancel-order.vue"),
			import("./components/dialog/cancel-order-v2.vue"),
			import("./components/dialog/complete-order-dialog.vue"),
			import("./components/editor-quill/index.vue"),
			import("./components/icon/svg.vue"),
			import("./components/icon-svg/index.vue"),
			// 抖动检测
			import("./components/shake-check/index.vue"),
			// image
			import("./components/image/index.vue"),
			import("./components/image/securet.vue"),
			import("./components/image/service-image.vue"),
			import("./components/image/texture.vue"),
			import("./components/image/watermask.vue"),
			import("./components/qrcode/qrcode.vue"),
			import("./components/query/query.vue"),
			import("./components/query-priority/order.vue"),
			import("./components/query-priority/priority.vue"),
			import("./components/scrollbar/index.vue"),
			import("./components/select/area.vue"),
			import("./components/select/currency.vue"),
			import("./components/select/attribute-multi.vue"),
			import("./components/select/attribute.vue"),
			import("./components/select/china-area.vue"),
			import("./components/select/customer.vue"),
			import("./components/select/equipment.vue"),
			import("./components/select/fans.vue"),
			import("./components/select/model_repair_item.vue"),
			import("./components/select/model_repair_level.vue"),
			import("./components/select/model_repair_team.vue"),
			import("./components/select/shop.vue"),
			import("./components/select/user.vue"),
			import("./components/select/wechat-menu.vue"),
			import("./components/select/size.vue"),
			import("./components/select/dealer-cascader.vue"), // 经销商+门店
			import("./components/swiper/swiper.vue"),
			import("./components/table/order_goods_table.vue"),
			import("./components/switch/index.tsx"),
			// 购买类型
			import("./components/tag/buy-type.vue"),

			// mark
			import("./components/watermark/watermark.vue")
		],
		install() {},
		async onLoad() {
			registerOssArchiveConfigLoader(async () => {
				return (await (service as any).ossArchive.getConfig()) || {};
			});
			if (!isStandalonePreviewPage()) {
				try {
					await startOssArchiveIntegrationPolling();
				} catch {
					// getConfig 无权限时不能阻断启动
				}
			}
			return {};
		}
	};
};
